import DesCatalogPropertiesViewModel from 'viewmodel/DesCatalogPropertiesViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';
import { DesAccConstants } from '../constant/desAccConstants';

export default class DesCatalogProperties extends DesBaseCatalogAcc {
    constructor() {
        super(DesCatalogPropertiesViewModel);
    }

    get attachments() {
        return this.getAttribute(DesAccConstants.ATTACHMENTS);
    }

    get partId() {
        return this.getAttribute(DesAccConstants.PART_ID);
    }

    getProps() {
        return {
            attachments: this.attachments,
            catalogspaceid: this.catalogspaceId,
            partid: this.partId,
            provider: this.provider
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, DesAccConstants.PART_ID];
    }
}

if (!window.customElements.get('des-catalog-properties')) {
    window.customElements.define('des-catalog-properties', DesCatalogProperties);
}
